export default __webpack_public_path__ + "static/media/14.c5f4723f.jpg";